import {createGlobalStyle} from 'styled-components';

const GlobalStyle = createGlobalStyle`

  *{
    padding: 0px;
    margin: 0px;
  }
  
  body{
    font-family: 'Montserrat', sans-serif;
  }

`

export default GlobalStyle;